// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow_modal__EbVC0","overlay":"ModalWindow_overlay__Hparz"};